<template>
  <div style="display: flex">
    <el-select
      :value="value"
      :disabled="disabled"
      filterable
      :allow-create="true"
      style="flex: 1;margin-right: 5px"
      @input="onInput"
    >
      <el-option
        v-for="(item,index) in contactList"
        :key="index"
        :label="item.contactPerson"
        :value="item.contactPerson"
      />
    </el-select>&nbsp;
    <el-link
      :class="value?'':'not-click'"
      @click="showContactDialog"
    >{{ $t('SeaExport.Detail') }}
    </el-link>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="right"
        label-width="100px"
      >
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { Company } from '@/class/model/mdm/Company'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'ContactPerson',
  props: {
    value: { type: String, default: '' },
    customerId: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      contactList: [],
      contactDialog: {
        visible: false,
        data: {}
      }
    }
  },
  watch: {
    customerId: {
      immediate: true,
      async handler(newVal) {
        const disabled = this.disabled
        const cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', newVal)
        if (!cmp || !cmp.cmpIdx) {
          this.contactList = []
          if (!disabled) {
            if (this.value !== '') {
              this.onInput('')
            }
          }
          return
        }
        this.contactList = await Company.loadContact(cmp.uuid)
        if (!disabled) {
          const defaultContact = await JobUtils.getCustomerContact(cmp.uuid, this.contactList)
          this.onInput(defaultContact)
        }
      }
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    showContactDialog() {
      if (!this.value) {
        return
      }
      for (const item of this.contactList) {
        if (item.contactPerson === this.value) {
          this.contactDialog.data = item
          this.contactDialog.visible = true
          return
        }
      }
      this.contactDialog.data = {}
      this.contactDialog.visible = true
    }
  }
}
</script>
